export function matchesOrganizationSearch(
  org: { name: string; currency: string | null; uid: string },
  search: string
): boolean {
  const query = search.trim().toLowerCase();
  return [org.name, org.currency, org.uid].some((value) =>
    value?.toLowerCase().includes(query)
  );
}

export function compareOrganizationNames(
  a: { name: string },
  b: { name: string },
  direction: "asc" | "desc"
): number {
  return direction === "asc"
    ? a.name.localeCompare(b.name)
    : b.name.localeCompare(a.name);
}
